import { CreateTokenResponse, User } from "./types";

const expiresInSeconds = 1800;
const formatWithBaseUrl = (url: string) => {
  if (
    document.location.hostname === "localhost" &&
    document.location.port === "3333"
  ) {
    url = "http://localhost:8080" + url;
  }
  return url;
};
export interface OperatorDemoConfig {
  verifyApiKey: boolean;
  throwError: boolean;
  depositError: boolean;
  withdrawError: boolean;
  responseTimeMs: number;
  slow: boolean;
}
export const fetchConfig = (): Promise<OperatorDemoConfig> => {
  return fetch(formatWithBaseUrl("/rest/admin/config")).then((r) => r.json());
};
export const updateConfig = (config: OperatorDemoConfig) => {
  return fetch(formatWithBaseUrl("/rest/admin/config"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(config),
  }).then((r) => r.json());
};
export const login = (user: User): Promise<CreateTokenResponse> => {
  let url = "/rest/admin/create-token/" + user.name + "/" + expiresInSeconds;
  url = formatWithBaseUrl(url);
  return fetch(url).then((r) => r.json());
};
export interface Game {
  id: string;
  name: string;
  category: string;
  aspect_ratio: string;
  orientation: string;
  images: { [key: string]: string };
}
export interface Lobby {
  games: Game[];
}
export const fetchCasinoLobby = (): Promise<Lobby> => {
  return fetch(
    "https://s3-eu-west-1.amazonaws.com/casino-public/games/games-test.json",
  ).then((r) => r.json());
};
